import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Login from './pages/login';
import Main from './pages/main';
import Qa from './pages/main/qa/list';
import Home from './pages/main/Home';
import * as serviceWorker from './serviceWorker';
import createHistory from 'history/createBrowserHistory';
import {Route, Switch, Router} from 'react-router-dom';
import 'antd/dist/antd.css';
import NewsList from "./pages/main/news/list";
import NewsDetail from "./pages/main/news/detail";
import List from "./pages/main/case/list";
import zhCN from 'antd/es/locale/zh_CN';
import {ConfigProvider} from "antd";
import QaDetail from "./pages/main/qa/detail";
import CaseDetail from "./pages/main/case/detail";

const hashHistory = createHistory();

let loginInfo = {
    isLogin: false,
};

ReactDOM.render(
  <React.StrictMode>
      <ConfigProvider locale={zhCN}>
        <Router history={hashHistory}>
          <Switch>
              <Route exact path="/login" component={Login} history={hashHistory} loginInfo={loginInfo} />
              <Main history={hashHistory} loginInfo={loginInfo}>
                  <Switch>
                      <Route exact path="/news" component={NewsList} history={hashHistory} />
                      <Route exact path="/news/add" component={NewsDetail} history={hashHistory} />
                      <Route exact path="/news/edit/:id" component={NewsDetail} history={hashHistory} />
                      <Route exact path="/qa" component={Qa} history={hashHistory} />
                      <Route exact path="/qa/add" component={QaDetail} history={hashHistory} />
                      <Route exact path="/qa/edit/:id" component={QaDetail} history={hashHistory} />
                      <Route exact path="/case" component={List} history={hashHistory} />
                      <Route exact path="/case/add" component={CaseDetail} history={hashHistory} />
                      <Route exact path="/case/edit/:id" component={CaseDetail} history={hashHistory} />
                      <Route exact path="/" component={Home} history={hashHistory} />
                  </Switch>
              </Main>
          </Switch>
      </Router>
      </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
